import { render, staticRenderFns } from "./ReduceDebtDetails.vue?vue&type=template&id=31383440&scoped=true&"
import script from "./ReduceDebtDetails.vue?vue&type=script&lang=js&"
export * from "./ReduceDebtDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31383440",
  null
  
)

export default component.exports